import { useVODService } from '@/app/context/DIContext/DIServices'
import { useVODStore } from '@/shared/store'
import { IVODServiceStreamIQ } from '@/shared/types/services/types/vodService/IVodServiceStreamIQ'

export function useGetVodRecommendationsStreamIQ(
    profileId: string,
    productId: string,
    type: string
) {
    const { vodCachedDetails } = useVODStore()

    const serviceNames = vodCachedDetails.filter(
        (item) => item.vodItemId === `vod:${productId}`
    )
    const { mapRecommendationsToVodRowViewProps } =
        useVODService() as IVODServiceStreamIQ

    const vodCategoryRows = [
        mapRecommendationsToVodRowViewProps({
            id: productId,
            title: '',
            handleGoToCategoryButtonClick: (
                itemId: string,
                title: string,
                type: string
            ) => {
                console.log(
                    `Navigating to category: ${title} with type ${type} and item id ${itemId}`
                )
            },
            maxHeight: 200,
            atmosphericUrl: '',
            isSkeletons: false,
            rowHeightPercentage: 100,
            cardRadiusDp: 8,
            hideTitle: false,
            hideCaptions: false,
            hideProgress: false,
            isHomeContentRow: true,
            query: type,
            serviceName: serviceNames[0].details?.serviceName || '',
            scrollPosition: {
                x: 0,
                y: 0,
            },
        }),
    ]

    return {
        vodCategoryRows,
    }
}
